import React, { Fragment } from "react";
import { connect } from "react-redux";
import { Link,withRouter } from "react-router-dom";
import autoBind from 'react-autobind';
import "./forgotPassword.css";
import { forgotPassword, changePassword } from "../../actions/login";
import { SOCIAL_MEDIA_LINKS } from '../utils/constants.';
import ubuilderBlue from '../../static/U-Builder_Logo_Blue_Color.png';
import uniracWhite from '../../static/Unirac_White.png';
import eyeOpened from '../../static/Icon material-remove-red-eye.svg';
import eyeClosed from '../../static/Icon awesome-eye-slash.svg';



class ForgotPassword extends React.Component {

    constructor(props) {
        super(props);
        autoBind(this);

        this.state = { email: '', password: '', confirm_password: '', count: 10, error: { email: '', password: '', confirm_password: '' }, buttonDisable: false, visiblePassword: false, visibleConfirmPassword: false };
        
        const appElement = document.querySelector('.App');
        if(appElement){
            const currentClass = appElement.classList[1];
            appElement.classList.replace(currentClass, "forgotpassword");
        }
    }

    componentWillUpdate() {
        if (this.props.change_password_success && this.state.count>0) {
            setTimeout(()=>{
                this.setState(prevState => ({
                    count: prevState.count - 1 
                }), () => {
                    if (this.state.count === 0) {
                        this.props.history.push('/login');
                    }
                })
            }, 1000)
        }
    }
    
        /**
     * Handling input change events.
     * @param  {Object} event 
     */
    handleInputChange(event) {
        const value = event.target.value;
        const name = event.target.name;
        this.setState({
            [name]: value
        });
        this.validateInputFields(name,value);
    }

    viewPassword() {
        this.setState({
            visiblePassword: !this.state.visiblePassword,
        })
    }

    viewConfirmPassword() {
        this.setState({
            visibleConfirmPassword: !this.state.visibleConfirmPassword,
        })
    }

    validateInputFields = (fieldName, value) => {
        let disable = false, errorMessage=null;
        if(fieldName==="email"){
            if(!value.includes("@")){
                disable = true;
                errorMessage = "Please enter valid email address";  
            }
            this.setState({
                error: {
                    ...this.state.error,
                    [fieldName]: errorMessage,
                },
            })
        }
        if(fieldName==="password"){
            if(value.length < 8){
                disable = true;
                errorMessage = "The password field must be contain atleast 8 characters";  
            }
            this.setState({
                error: {
                    ...this.state.error,
                    [fieldName]: errorMessage,
                },
            })
        }
        if(fieldName === "confirm_password"){
            if(value !== this.state.password){
                disable = true;
                errorMessage = "Passwords doesn't match";
            }
            this.setState({
                error: {
                    ...this.state.error,
                    [fieldName]: errorMessage,
                },
            })
        }

        this.setState({
            buttonDisable: disable
        })

    }
    /**
         * Form submit function with validation check.
         * @param  {Object} event 
         */
    formSubmit = (event) => {
        event.preventDefault();
        if (this.props.match?.params?.uid && this.props.match?.params?.token) {
            this.props.changePassword({new_password: this.state.password, password_repeat: this.state.confirm_password, token: this.props.match?.params?.token, uid: this.props.match?.params?.uid});
        }
        else {
            this.props.forgotPassword({email: this.state.email});
        }
    }


    render() {
        const inputTypeForPassword = this.state.visiblePassword ? "text" : "password";
        const EyeIconForPassword = this.state.visiblePassword ? eyeOpened : eyeClosed; 
        const inputTypeForConfirmPassword = this.state.visibleConfirmPassword ? "text" : "password";
        const EyeIconForConfirmPassword = this.state.visibleConfirmPassword ? eyeOpened : eyeClosed; 

        return (
            <Fragment>
                <div className="container">
                    <div>
                        <div className={`forgot-password ${(this.props.match?.params?.uid && this.props.match?.params?.token) ? `change-password` : ``}`}>
                            <form onSubmit={this.formSubmit} style={{ marginTop: '-10px' }} className="justify-content-center">
                                <div className="text-center forgot-password-title">
                                    <img src={ubuilderBlue} className="ubuilder-blue-logo" alt="ubuider-blue-logo" />
                                </div>
                                {!(this.props.match?.params?.uid && this.props.match?.params?.token) ?
                                    (<>
                                        <div className="form-group email">
                                            <input type="email" className={`form-control ${this.state.error.email ? "invalid" : ""}`} value={this.state.email}
                                                onChange={this.handleInputChange} name="email" required placeholder="Enter Your Email ID" />
                                            <span className="error-message">{this.state.error.email}</span>

                                        </div>
                                
                                        <button type="submit" className="btn btn-block submitButtonColor" disabled={this.state.buttonDisable}>
                                            Send Reset Link
                                            <img src={require('../../static/forward_arrow_icon.svg')} className="forward-icon" alt="forward-icon"/>
                                        </button>
                                    </>) :
                                    (<>
                                        <div className="form-group password">
                                            <input type={inputTypeForPassword} className={`form-control ${this.state.error.password ? "invalid" : ""}`} value={this.state.password}
                                                onChange={this.handleInputChange} name="password" required placeholder="Enter Your Password" />
                                            <span className="view-password" onClick={this.viewPassword}><img src={EyeIconForPassword} alt="eye-icon"/></span>
                                            <span className="error-message">{this.state.error.password}</span>
                                        </div>
                                        <div className="form-group confirm-password">
                                            <input type={inputTypeForConfirmPassword} className={`form-control ${this.state.error.confirm_password ? "invalid" : ""}`} value={this.state.confirm_password}
                                                onChange={this.handleInputChange} name="confirm_password" required placeholder="Confirm Your Password" />
                                            <span className="view-password" onClick={this.viewConfirmPassword}><img src={EyeIconForConfirmPassword} alt="eye-icon"/></span>
                                            <span className="error-message">{this.state.error.confirm_password}</span>
                                        </div>
                                        <button type="submit" className="btn btn-block submitButtonColor" disabled={this.state.buttonDisable}>
                                            Set New Password
                                            <img src={require('../../static/forward_arrow_icon.svg')} className="forward-icon" alt="forward-icon"/>
                                        </button>
                                        {this.props.change_password_success && (
                                            <>
                                                <p className="redirecting-phrase">Redirecting to the login page in <span className="timer">{this.state.count}s</span></p>
                                            </>
                                        )}
                                    </>)
                                }
                                
                            </form>
                            <hr/>

                            <div className="text-center loginRegNavLink">
                                Already have an account ?
                                <Link to={'/login'} className="login-link"> Login</Link>/<Link to={'/registration'} className="login-link"> Sign up</Link>
                            </div>
                            <div className="text-center social-media-links">
                                <a href={SOCIAL_MEDIA_LINKS.facebook}><img src={require('../../static/Icon awesome-facebook.svg')} alt="facebook-icon"/></a>
                                <a href={SOCIAL_MEDIA_LINKS.twitter}><img src={require('../../static/Icon awesome-twitter.svg')} alt="twitter-icon"/></a>
                                <a href={SOCIAL_MEDIA_LINKS.linkedin}><img src={require('../../static/Icon awesome-linkedin.svg')} alt="linkedin-icon"/></a>
                                <a href={SOCIAL_MEDIA_LINKS.instagram}><img src={require('../../static/Icon awesome-instagram.svg')} alt="instagram-icon"/></a>
                                <a href={SOCIAL_MEDIA_LINKS.instagram}><img src={require('../../static/Icon awesome-youtube.svg')} alt="youtube-icon"/></a>
                            </div>
                        </div>
                    </div>
                    <img src={uniracWhite} className="unirac-white-logo" alt="unirac-white-logo"/>
                </div>
            </Fragment>
        )
    }
}

function mapStateToProps(state, props) {
    return {
        change_password_success: state.loginInfo.change_password_success,
    };
  }


export default connect(mapStateToProps, { forgotPassword, changePassword })(withRouter(ForgotPassword))